"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => ({
  formControlRoot: {
    display: "flex",
    position: "relative"
  },
  formControlLabelRoot: {
    marginRight: 0,
    paddingRight: 40
  },
  formControlLabel: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "& span": {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      "& span.count": {
        position: "absolute",
        right: 0,
        top: "50%",
        transform: "translate(0, -50%)"
      }
    }
  },
  checkbox: {
    "&:hover": {
      background: "none !important"
    }
  }
}));
var _default = exports.default = styles;